<script setup>
import { ref, onMounted } from "vue"
import LiveScore from "@/components/organisms/LiveScore.vue"
import LatestWeeklyWashigumi from "@/components/organisms/LatestWeeklyWashigumi.vue"
import LatestArticles from "@/components/organisms/LatestArticles.vue"
import LatestDraft from "@/components/organisms/LatestDraft.vue"

import Topics from "@/components/molecules/TopicsMolecule.vue"
import Ad1 from "@/components/molecules/Ad1Molecule.vue"
import Ad1SP from "@/components/molecules/Ad1SPMolecule.vue"
import Ad2 from "@/components/molecules/Ad2Molecule.vue"
import AdInterstitial from "@/components/molecules/AdInterstitial.vue"

const isMounted = ref(false)
// ウィンドウサイズを確認、640px以上ならisLargeScreen = true
const isLargeScreen = ref(window.innerWidth >= 640)
const handleResize = () => {
  isLargeScreen.value = window.innerWidth >= 640
}

onMounted(() => {
  window.addEventListener("resize", handleResize)
  isMounted.value = true
})
</script>

<template>
  <AdInterstitial :is-large-screen="isLargeScreen" />
  <div class="css__main-area">
    <template v-if="isMounted">
      <div v-if="isLargeScreen" id="ads-ADU-20PG6C49"></div>
      <div v-else id="ads-ADU-6AM1EH1T"></div>
    </template>
    
    <!-- 最近のトピック -->
    <Topics />
    <Ad1 v-if="isMounted" :is-large-screen="isLargeScreen" />

    <section style="min-height: 25em;">
      <!-- きょうの試合のスコア速報 -->
      <LiveScore />
    </section>

    <section style="min-height: 70em;">
      <!-- 最新の記事 -->
      <LatestArticles />
    </section>

    <Ad2 v-if="isMounted" :is-large-screen="isLargeScreen" />

    <section style="min-height: 20em;">
      <!-- 週刊鷲組 -->
      <LatestWeeklyWashigumi />
    </section>

    <Ad1SP v-if="isMounted" :is-large-screen="isLargeScreen" />

    <section style="min-height: 20em;">
      <!-- ドラフト関連 -->
      <LatestDraft />
    </section>
  </div>
</template>

<style></style>